module.exports = __webpack_public_path__ + "img/análise inicial 1.2560d47d.webp";